import type { State } from '#~/depot/types.js';

/**
 * Count unread requests for intervention, including closed toast history.
 * Per rule: investigate-before-adding (ai.knowledge/global) — new helper
 * next to notifications/utils.ts; review-3 requires a depot-free selector.
 */
export const unreadActionableCount = (notifications: State['notifications']): number =>
  Object.values(notifications).reduce(
    (count, [notification, , status]) =>
      notification.actionable === true && !status.isRead ? count + 1 : count,
    0
  );
